import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { DropdownService } from 'src/app/services/dropdown.service';

@Component({
  selector: 'app-parachutes',
  templateUrl: './parachutes.component.html',
  styleUrls: ['./parachutes.component.scss']
})
export class ParachutesComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  constructor(private dropdownService: DropdownService) {}

  readonly mainParachuteDisplay = (chute: any): string =>
    chute ? (chute.Base === null && chute.cuteType === null && chute.main === null) ? '' : `${chute.Base} | ${chute.chuteType} | ${chute.main}` : '';
  readonly riggerDisplay = (rigger: any): string =>
    rigger ? (rigger?.firstName === null && rigger?.lastName === null && rigger?.value === null) ? '' : `${rigger?.firstName} ${rigger?.lastName}` : '';
  readonly drogueParachuteDisplay = (chute: any): string =>
    chute ? (chute.Base === null && chute.drogue === null) ? '' : `${chute.Base} | ${chute.drogue}` : '';
  readonly reserveParachuteDisplay = (chute: any): string =>
    chute ? (chute.Base === null && chute.reserve === null) ? '' : `${chute.Base} | ${chute.reserve}` : '';

  userInfo = JSON.parse(sessionStorage.getItem('userInfo'));

  mainParachutes = [];
  riggers = [];
  reserveParachutes = [];
  drogueParachutes = [];
  drogueRiggers = [];
  reserveRiggers = [];
  mainManufacturers = [
    {
      name: '',
      id: null,
      active: 1,
    },
    {
      name: 'Airborne Systems',
      id: 1,
      active: 1,
    },
    {
      name: 'Performance Designs',
      id: 2,
      active: 1,
    },
    {
      name: 'Irvin',
      id: 3,
      active: 1,
    },
    {
      name: 'Other',
      id: 4,
      active: 1,
    },
    {
      name: 'Eiff',
      id: 5,
      active: 0,
    },
    {
      name: 'Para Flite',
      id: 6,
      active: 0,
    },
    {
      name: 'Quantum',
      id: 7,
      active: 0,
    },
    {
      name: 'Strong Enterprise',
      id: 8,
      active: 0,
    }
  ];
  mainActiveManufacturers = this.mainManufacturers.filter((manufacturer) => manufacturer.active === 1);
  dropDownMainManufacturers = this.mainActiveManufacturers;
  drogueManufacturers = [
    {
      name: '',
      id: null,
      active: 1,
    },
    {
      name: 'BRS',
      id: 1
    },
    {
      name: 'G7T',
      id: 2
    },
    {
      name: 'Wingate',
      id: 3
    },
    {
      name: 'Other',
      id: 4
    }
  ];
  reserveManufacturers = [
    {
      name: '',
      id: null,
      active: 1,
    },
    {
      name: 'Airborne Systems',
      id: 1
    },
    {
      name: 'Butler',
      id: 2
    },
    {
      name: 'Para Flight',
      id: 3
    },
    {
      name: 'Other',
      id: 4
    }
  ];
  deploymentMethods = [ null, 'RSL', 'AAD', 'Manual', 'Other'];

  mainParachutes$ = this.dropdownService
    .getMainParachutes()
    .subscribe((chutes) => (this.mainParachutes = chutes.value));
  drogueParachutes$ = this.dropdownService
    .getDrogueParachutes()
    .subscribe((chutes) => (this.drogueParachutes = chutes.value));
  reserveParachutes$ = this.dropdownService
    .getReserveParachutes()
    .subscribe((chutes) => (this.reserveParachutes = chutes.value));
  riggers$ = this.dropdownService
    .getAllJumpers()
    .subscribe(
      (riggers) => (
        (this.riggers = riggers.value),
        (this.drogueRiggers = riggers.value),
        (this.reserveRiggers = riggers.value)
      )
    );
  riggingLocations$: Observable<any> = this.dropdownService.getMadbHomeBases().pipe(shareReplay(1));
  riggingLocations: any;
  riggingLocationsSpike: any;
  riggingLocationsSpike$: Observable<any>;
  drogueRiggingLocationsSpike$: Observable<any>;
  reserveRiggingLocationsSpike$: Observable<any>;
  filteredMainParachutes$: Observable<any[]>;
  filteredDrogueParachutes$: Observable<any[]>;
  filteredReserveParachutes$: Observable<any[]>;
  filteredRiggers$: Observable<any[]>;
  filteredDrogueRiggers$: Observable<any[]>;
  filteredReserveRiggers$: Observable<any[]>;
  mainParachuteSubscription: Subscription;
  formSubscription: Subscription;
  riggerSubscription: Subscription;
  jumpersSub: Subscription;
  homeBasesSub: Subscription;
  baseSub: Subscription;
  spikeLocationsSub: Subscription;
  mainRigLocIdSub: Subscription;
  drgBasesSub: Subscription;
  reserveBasesSub: Subscription;
  drogueRiggingLocationsSpike: any;
  drgSpikeBasesSub: Subscription;
  drgSpikeLocationsSub: Subscription;
  drogueRigLocIdSub: Subscription;
  reserveRiggingLocationsSpike: any;
  reserveSpikeBasesSub: Subscription;
  reserveRigLocIdSub: Subscription;
  rigLocSub: Subscription;
  drgRigLocationsSub: Subscription;
  drogueRiggingLocations: any;

  ngOnInit(): void {
    this.rigLocSub = this.riggingLocations$.subscribe({
      next: (locations) => {
        this.riggingLocations = locations;
      }
    });

    this.drgRigLocationsSub = this.riggingLocations$.subscribe({
      next: (locations) => {
        this.drogueRiggingLocations = locations;
      }
    });

    

    // here we get the main riggers locaion details if there is an id on load. we also need to get a list of spike locations based on the spike
    this.mainRigLocIdSub = this.form.get('mainRigLocId').valueChanges.subscribe({
      next: (value) => {
        if (value && this.form.get('mainRigLocDetails').value === null) {
          this.baseSub = this.dropdownService.getBaseById(value).subscribe({
            next: (base) => {
              this.form.get('mainRigLocDetails').patchValue(base);
              // if the riggingLocations$ does not have the base, we add it to the list
              if (!this.riggingLocations?.includes(base)) {
                let formattedBase = base
                if(base.name && !formattedBase.text) {formattedBase['text'] = base.name};
                if(base.code && !formattedBase.baseCode) {formattedBase['baseCode'] = base.code};
                if(base.code && !formattedBase.value) {formattedBase['value'] = base.code};
                if (!this.riggingLocations.find((location) => location.id === base.id)) {
                  this.riggingLocations = [...this.riggingLocations, base]
                } 
              }

              this.spikeLocationsSub = this.dropdownService.getSpikeBases(base?.baseCode).subscribe({
                next: (response) => {
                  this.riggingLocationsSpike = response.value
                }
              })
            },
          });
        }
      }
    });
    // here we get the drogue riggers locaion details if there is an id on load. we also need to get a list of spike locations based on the spike
    this.drogueRigLocIdSub = this.form.get('drgRigLocationId').valueChanges.subscribe({
      next: (value) => {
        if ((this.form.get('drgRiggerSpikeBaseDetails')?.value === null) && this.form.get('drgRigLocationId').value) {
          this.drgSpikeBasesSub = this.dropdownService.getBaseById(value).subscribe({
            next: (base) => {
              let formattedBase = base
              if(!this.riggingLocations.includes(base)) { 
                formattedBase['text'] = base.name;
                formattedBase['value'] = base.code
                formattedBase['baseCode'] = base.code
                if (!this.drogueRiggingLocations.find((location) => location.id === formattedBase.code)) {
                  this.drogueRiggingLocations = [...this.drogueRiggingLocations, base]
                }
              }
              this.form.get('drgRigLocationDetails').patchValue(formattedBase);
              this.drgSpikeLocationsSub = this.dropdownService.getSpikeBases(formattedBase?.baseCode).subscribe({
                next: (response) => {
                  this.drogueRiggingLocationsSpike = response.value
                }
              })
            }
          })
        }
      }
    });
    // here we get the reserve riggers locaion details if there is an id on load. we also need to get a list of spike locations based on the spike
    this.reserveRigLocIdSub = this.form.get('reserveRigLocId').valueChanges.subscribe({
      next: (value) => {
        if ((this.form.get('reserveRigLocDetails')?.value === null) && this.form.get('reserveRigLocId').value) {
          this.reserveBasesSub = this.dropdownService.getBaseById(value).subscribe({
            next: (base) => {
              let formattedBase = base
              if(!this.riggingLocations.includes(base)) { 
                formattedBase['text'] = base.name;
                formattedBase['value'] = base.code
                formattedBase['baseCode'] = base.code
                if (!this.riggingLocations.find((location) => location.id === formattedBase.code)) {
                  this.riggingLocations = [...this.riggingLocations, base]
                }
              }
              this.form.get('reserveRigLocDetails').patchValue(formattedBase);
              this.reserveSpikeBasesSub = this.dropdownService.getSpikeBases(formattedBase?.baseCode).subscribe({
                next: (response) => {
                  this.reserveRiggingLocationsSpike = response.value
                }
              })
            }
          })
        }
      }
    });

    this.filteredMainParachutes$ = this.form.get('mainParachute').valueChanges.pipe(
      startWith(''),
      map((value) => this._parachuteFilter(value || ''))
    );
    this.filteredRiggers$ = this.form.get('mainRiggerDetails').valueChanges.pipe(
      startWith(''),
      map((value) => this._riggerFilter(value || ''))
    );
    this.filteredDrogueParachutes$ = this.form.get('drgName').valueChanges.pipe(
      startWith(''),
      map((value) => this._drogueParachuteFilter(value || ''))
    );
    this.filteredDrogueRiggers$ = this.form.get('drgRiggerDetails').valueChanges.pipe(
      startWith(''),
      map((value) => this._drogueRiggerFilter(value || ''))
    );
    this.filteredReserveParachutes$ = this.form.get('reserveParachuteDetails').valueChanges.pipe(
      startWith(''),
      map((value) => this._reserveParachuteFilter(value || ''))
    );
    this.filteredReserveRiggers$ = this.form.get('reserveRiggerDetails').valueChanges.pipe(
      startWith(''),
      map((value) => this._reserveRiggerFilter(value || ''))
    );
    // here we get the main parachute details if there is one on load
    this.formSubscription = this.form.get('mainNum').valueChanges.subscribe({
      next: (value) => {
        if (value && this.form.get('mainParachute').value === null) {
          this.mainParachuteSubscription = this.dropdownService.getMainParachutes().subscribe({ 
            next: (chutes) => {
              const chuteDetails = chutes.value.find((chute: any) => chute.main === value)
              this.form.get('mainParachute').patchValue(chuteDetails);
            }
          });
        }
      }
    })
    // here we make a list for the dropdown main manufacturers which is the union of the active manufacturers and the selected manufacturer if it is inactive
    this.form.get('mainRigManufId').valueChanges.subscribe({
      next: (value) => {
        if (value && value > 4) {
          const selectedManufacturer = this.mainManufacturers.find((manufacturer) => manufacturer.id === value)
          this.dropDownMainManufacturers.push(selectedManufacturer)
        }
      }
    })
    
    // here we make a list for the dropdown drogue manufacturers which is the union of the active manufacturers and the selected manufacturer if it is inactive
    this.form.get('drgRigManufId').valueChanges.subscribe({
      next: (value) => {
        if (value && value > 4) {
          const selectedManufacturer = this.mainManufacturers.find((manufacturer) => manufacturer.id === value)
          this.drogueManufacturers.push(selectedManufacturer)
        }
      }
    })
  }

  onMainParachuteChange(event: any) {
    this.form.get('mainNum').patchValue(event.option.value.main);
  }

  onBaseChange(event: any) {
    this.form.get('mainRigLocId').patchValue(event.value)
    if (event.value === null) {
      this.form.get('mainRigLocDetails').patchValue(null);
      this.form.get('mainRigLocName').patchValue(null);
      this.form.get('mainRiggerSpikeBaseId').patchValue(null);
      this.form.get('mainRiggerSpikeBaseDetails').patchValue(null);
    } else {
      this.homeBasesSub = this.dropdownService.getMadbHomeBases().subscribe({
        next: (bases) => {
          const selectedBase = bases.filter((base) => base.id === event.value)[0]
          this.form.get('mainRigLocDetails').patchValue(selectedBase);
          this.spikeLocationsSub = this.dropdownService.getSpikeBases(selectedBase.baseCode).subscribe({
            next: (response) => {
              this.riggingLocationsSpike = response.value
            }
          })
        }
      })
    }
  }

  onMainManufChange(event: any) {
    const chosenManufacturer = this.mainManufacturers.find((manufacturer) => manufacturer.id === event.value)
    this.form.get('mainRigManufDetails').patchValue(chosenManufacturer);
  }
  
  onMainSpikeChange(event: any) {
    const selectedSpike = this.riggingLocationsSpike.filter((spike) => spike.id === event.value)[0]
    this.form.get('mainRiggerSpikeBaseDetails').patchValue(selectedSpike)
  }

  onDrogueSpikeChange(event: any) {
    const selectedSpike = this.drogueRiggingLocationsSpike.filter((spike) => spike.id === event.value)[0]
    this.form.get('drgRiggerSpikeBaseDetails').patchValue(selectedSpike)
  }

  onRiggerSelection(rigger: any) {
    this.form.get('mainRiggerId').patchValue(rigger.id)
  }

  onDrogueParachuteChange(event: any) {
    this.form.get('drgNum')?.patchValue(event?.option?.value?.drogue);
  }

  onDrogueManufacturerChange(event: any) {
    const chosenManufacturer = this.drogueManufacturers.find((manufacturer) => manufacturer.id === event.value)
    this.form.get('drgManufDetails')?.patchValue(chosenManufacturer);
  }

  onDrogueRiggingLocationChange(event: any) {
    this.form.get('drgRigLocationId').patchValue(event.value)
    if (event.value === null) {
      this.form.get('drgRigLocationDetails').patchValue(null);
      this.form.get('drgRiggerSpikeBaseID').patchValue(null);
      this.form.get('drgRiggerSpikeBaseDetails').patchValue(null);
    } else {
      this.drgBasesSub = this.dropdownService.getMadbHomeBases().subscribe({
        next: (bases) => {
          const selectedBase = bases.filter((base) => base.id === event.value)[0]
          this.form.get('drgRigLocationDetails').patchValue(selectedBase);
          this.drgSpikeBasesSub = this.dropdownService.getSpikeBases(selectedBase.baseCode).subscribe({
            next: (response) => {
              this.drogueRiggingLocationsSpike = response.value
            }
          })
        }
      });
    }
  }

  onDrogueRiggerSelection(rigger: any) {
    this.form.get('drgRiggerId').patchValue(rigger.id)
  }

  onReserveManufacturerChange(event: any) {
    const chosenManufacturer = this.reserveManufacturers.find((manufacturer) => manufacturer.id === event.value)
    this.form.get('reserveRigManufDetails')?.patchValue(chosenManufacturer);
    this.form.get('reserveRigManufName')?.patchValue(chosenManufacturer.name);
  }

  onReserveRiggingLocationChange(event: any) {
    this.form.get('reserveRigLocId').patchValue(event.value)
    if (event.value === null) {
      this.form.get('reserveRigLocDetails').patchValue(null);
    } else {
      this.reserveBasesSub = this.dropdownService.getMadbHomeBases().subscribe({
        next: (bases) => {
          const selectedBase = bases.filter((base) => base.id === event.value)[0]
          this.form.get('reserveRigLocDetails').patchValue(selectedBase);
          this.reserveSpikeBasesSub = this.dropdownService.getSpikeBases(selectedBase.baseCode).subscribe({
            next: (response) => {
              this.reserveRiggingLocationsSpike = response.value
            }
          })
        }
      });
    }
  }

  onReserveParachuteChange(event: any) {
    this.form.get('reserveNum')?.patchValue(event?.option?.value?.reserve);
  }

  onReserveRiggerSelection(rigger: any) {
    this.form.get('reserveRiggerId').patchValue(rigger.id)
  }


  private _parachuteFilter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();
    
    return [{Base: null, cuteType: null, main: null}, ...this.mainParachutes.filter(
      (chute: any) =>
        chute?.Base.toLowerCase().includes(filterValue) ||
        chute?.chuteType.toLowerCase().includes(filterValue) ||
        chute?.main.toLowerCase().includes(filterValue)
    ).slice(0, 50)];
  }

  private _riggerFilter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();

    return [ {firstName: null, lastName: null, value: null}, ...this.riggers.filter(
      (rigger: any) =>
        rigger?.firstName.toLowerCase().includes(filterValue) ||
        rigger?.lastName.toLowerCase().includes(filterValue)
    )];
  }

  private _drogueParachuteFilter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();
    if (!value || filterValue === '') {
      this.form.get('drgNum').patchValue(null);
      return [{Base: null, drogue: null}, ...this.drogueParachutes.slice(0, 50)];
    }

    return [{Base: null, drogue: null}, ...this.drogueParachutes.filter(
      (chute: any) =>
        chute?.Base.toLowerCase().includes(filterValue) ||
        chute?.drogue.toLowerCase().includes(filterValue)
    )];
  }

  private _drogueRiggerFilter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();
    if (!value || filterValue === '') {
      this.form.get('drgRiggerId').patchValue(null);
      return [{firstName: null, lastName: null, value: null}, ...this.drogueRiggers.slice(0, 50)];
    }

    return [{firstName: null, lastName: null, value: null}, ...this.drogueRiggers.filter(
      (rigger: any) =>
        rigger?.firstName.toLowerCase().includes(filterValue) ||
        rigger?.lastName.toLowerCase().includes(filterValue)
    )];
  }

  private _reserveParachuteFilter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();
    if (!value || filterValue === '') {
      this.form.get('reserveNum').patchValue(null);
      return [{ Base: null, reserve: null }, ...this.reserveParachutes.slice(0, 50)];
    }
    
    return[{ Base: null, reserve: null }, ...this.reserveParachutes.filter(
      (chute: any) =>
        chute?.Base.toLowerCase().includes(filterValue) ||
        chute?.reserve.toLowerCase().includes(filterValue)
    )];
  }

  private _reserveRiggerFilter(value: string): string[] {
    const filterValue = value.toString().toLowerCase();
    if (!value || filterValue === '') {
      this.form.get('reserveRiggerId').patchValue(null);
      return [{firstName: null, lastName: null, value: null}, ...this.reserveRiggers.slice(0, 50)];
    }

    return [{firstName: null, lastName: null, value: null}, ...this.reserveRiggers.filter(
      (rigger: any) =>
        rigger?.firstName.toLowerCase().includes(filterValue) ||
        rigger?.lastName.toLowerCase().includes(filterValue)
    )];
  }

  ngOnDestroy(): void {
    this.mainParachutes$.unsubscribe();
    this.drogueParachutes$.unsubscribe();
    this.reserveParachutes$.unsubscribe();
    this.riggers$.unsubscribe();
    this.mainParachuteSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();
    this.riggerSubscription?.unsubscribe();
    this.jumpersSub?.unsubscribe();
    this.homeBasesSub?.unsubscribe();
    this.spikeLocationsSub?.unsubscribe();
    this.mainRigLocIdSub?.unsubscribe();
    this.drgBasesSub?.unsubscribe();
    this.reserveBasesSub?.unsubscribe();
    this.drgSpikeBasesSub?.unsubscribe();
    this.drgSpikeLocationsSub?.unsubscribe();
    this.drogueRigLocIdSub?.unsubscribe();
    this.reserveSpikeBasesSub?.unsubscribe();
    this.reserveRigLocIdSub?.unsubscribe();
    this.rigLocSub?.unsubscribe();
  }
}
